import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { CompanyOnboardingRequest, CompanyOnboardingResponse, VerifyOtpRequest, VerifyOtpResponse } from '../models/company-onboarding.model';
import { environment } from 'environments/environment';
import { CompanyCompletedOnBoardResponse } from '@edtech-ui/core/models/onBord-company/create-onBoard-company';
import { CompanyDashboardResponse } from '@edtech-ui/core/models/onBord-company/company-dashboard';
import { CompanyProfileResponse } from '@edtech-ui/core/models/onBord-company/company-profile';
import { CompanyPublishJobDetailsResponse, CompanyPublishPayload } from '@edtech-ui/core/models/company-management/company-approval-status';

@Injectable({
	providedIn: 'root'
})
export class CompanyOnboardingService {

	companyApiUrl = environment.companyApiUrl;

	private companyRegistrationSubject = new BehaviorSubject<any | null>(this.loadInitialRegistrationData());
	companyRegistration$ = this.companyRegistrationSubject.asObservable();

	private companyProfileSubject = new BehaviorSubject<any | null>(null);
	companyProfile$ = this.companyProfileSubject.asObservable();

	setCompanyProfile(data: any) {
		this.companyProfileSubject.next(data);
	}


	private loadInitialRegistrationData(): any | null {
		if (typeof window !== 'undefined' && window.localStorage) {
			const stored = localStorage.getItem('company_registration_data');
			if (stored) {
				try {
					return JSON.parse(stored);
				} catch (e) {
					console.error('Error parsing stored company registration data', e);
					return null;
				}
			}
		}
		return null;
	}


	setCompanyRegistrationData(data: any) {
		if (typeof window !== 'undefined' && window.localStorage) {
			if (data) {
				localStorage.setItem('company_registration_data', JSON.stringify(data));
			} else {
				localStorage.removeItem('company_registration_data');
			}
		}
		this.companyRegistrationSubject.next(data);
	}


	getCompanyRegistrationData() {
		return this.companyRegistrationSubject.value;
	}


	constructor(private http: HttpClient) { }


	onboardCompany(data: CompanyOnboardingRequest): Observable<CompanyOnboardingResponse> {
		return this.http.post<CompanyOnboardingResponse>(`${this.companyApiUrl}/register/send-otp`, data);
	}


	verifyOtp(data: VerifyOtpRequest): Observable<VerifyOtpResponse> {
		const headers = new HttpHeaders({
			'Content-Type': 'application/json',
			'X-Tenant': 'ace'
		});
		return this.http.post<VerifyOtpResponse>(`${this.companyApiUrl}/register/verify-otp`, data, { headers });
	}


	postCompanyOnBoard(payload: FormData): Observable<CompanyCompletedOnBoardResponse> {
		const companyToken = localStorage.getItem('session_token');

		return this.http.post<CompanyCompletedOnBoardResponse>(`${this.companyApiUrl}/register/complete-profile`, payload,
			{
				headers: { Authorization: `Bearer ${companyToken}` }
			}
		);
	}


	getCompanyDashboardStats(companyId: string): Observable<CompanyDashboardResponse> {
		const params = new HttpParams().set('company_id', companyId)
		return this.http.get<CompanyDashboardResponse>(`${this.companyApiUrl}/dashboard`, { params })
	}


	getCompanyProfile(): Observable<CompanyProfileResponse> {
		return this.http.get<CompanyProfileResponse>(`${this.companyApiUrl}/me/profile`).pipe(
			tap(response => {
				if (response && response.Success) {
					this.companyProfileSubject.next(response.Data);
				}
			})
		);
	}


	putCompanyProfile(payload: FormData, companyId: string): Observable<any> {
		return this.http.put<any>(`${this.companyApiUrl}/me/profile/${companyId}`, payload);
	}


}
